export default "__VITE_ASSET__CjPNNQbs__"